<template>
  <div class="productFeaturesContainer">
    <p class="featurestitle">PRODUCT FEATURES</p>
    <p class="featurestitle2">Understand what sets us apart</p>
    <div class="triangleBack"></div>
    <div class="rectangleBack">

      <div class="feature feature1">
        <div class="featureText">
          <p class="featureTitle">所見即所得</p>
          <p class="featureContent">整個翻譯，譯審過程完整地保留文章語境</p>
        </div>
        <div class="featurePicture"></div>
      </div>
        
      <div class="feature feature2">
        <div class="featureText">
          <p class="featureTitle">强大的搜索引擎</p>
          <p class="featureContent">轻松地应对千万级的大型记忆库</p>
        </div>
        <div class="featurePicture"></div>
      </div>
        
      <div class="feature feature3">
        <div class="featureText">
          <p class="featureTitle">精细的原稿分析</p>
          <p class="featureContent">细致到所有文件内、文件之间，协同任务之间的所有句子的相互匹配关系都尽在掌握之中，随时可以查看各类匹配句子</p>
        </div>
        <div class="featurePicture"></div>
      </div>
        
      <div class="feature feature4">
        <div class="featureText">
          <p class="featureTitle">全任务流程控制</p>
          <p class="featureContent">任务计划及实时进程管理，可实时监测和控制翻译、译审进程</p>
        </div>
        <div class="featurePicture"></div>
      </div>

    </div>
    <div class="featurelist">
      <div class="list1">
        <ul>
          <li><i>.</i>1</li>
          <li><i>.</i>2</li>
          <li><i>.</i>3</li>
        </ul>
      </div>
      <div class="list2"></div>
      <div class="list3">
        <ul>
          <li><i>.</i>1</li>
          <li><i>.</i>2</li>
          <li><i>.</i>3</li>
        </ul>
      </div>
    </div>

    <div class="solutions">
      <span class="solutionsTitle">Stakeholder Solutions</span>
      <div class="solutionsContent">
        <div class="solutionContent solutionContent1">
          <div class="solutionContentTop"></div>
          <div class="solutionContentBottom">
            <p>Individual Translators</p>
          </div>
        </div>
        <div class="solutionContent solutionContent2">
          <div class="solutionContentTop"></div>
          <div class="solutionContentBottom">
            <p>Project Teams</p>
          </div>
        </div>
        <div class="solutionContent solutionContent3">
          <div class="solutionContentTop"></div>
          <div class="solutionContentBottom">
            <p>Companies</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState,mapMutations} from 'vuex'
export default {
  name: 'top',
  data () {
    return {
      msg: '',
      lang:'zh-CN',
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      
    })
  },
  computed: {
    
  },
  methods: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
.productFeaturesContainer{
    padding: 0;
    margin-top:40px;
}
.productFeaturesContainer{
    padding: 0;
    margin-top:40px;
}
.productFeaturesContainer .featurestitle{margin-top:217px;margin-left:126px;width: 300px;
  height: 32px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 26px;
  line-height: 32px;
  color: #AFAFAF;
  text-align:left;
}
.productFeaturesContainer .featurestitle2{margin-top:32px;margin-left:126px;
  width: 754px;
  height: 118px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 48px;
  line-height: 59px;
  color: #000000;
  text-align:left;
}
.productFeaturesContainer .triangleBack{
  width: 0;
  height: 0;
  background: #F8F8F8;
  border-bottom: 300px solid #F8F8F8;
  border-left: 100vw solid #fff;
}
.productFeaturesContainer .rectangleBack{
  width: 100%;
  background: #F8F8F8;
}
.productFeaturesContainer .rectangleBack .feature{padding-bottom:134px;}
.productFeaturesContainer .rectangleBack .feature .featureText{
  width:602px;
  height:544px;
  display:inline-block;
  padding-right:127px;
}
.productFeaturesContainer .rectangleBack .feature .featureText .featureTitle{
  height: 53px;
  width:100%;
  font-family: PingFang HK;
  font-style: normal;
  font-weight: 300;
  font-size: 38px;
  line-height: 53px;
  text-align:left;
  color: #000000;
  margin-top:200px;
}
.productFeaturesContainer .rectangleBack .feature .featureText .featureContent{
  height: 53px;
  font-family: PingFang HK;
  font-style: normal;
  font-weight: 200;
  font-size: 26px;
  line-height: 36px;
  text-align:left;
  color: #000000;
}
.productFeaturesContainer .rectangleBack .feature .featurePicture{
  width:556px;
  height:544px;
  background: #FFFFFF;
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.1);
  border-radius: 18px;
  display:inline-block;
  vertical-align: bottom;
}
.productFeaturesContainer .featurelist{
  height:665px;
  padding:187px 0 153px 0;
}
.productFeaturesContainer .featurelist .list1{
  width: 255px; 
  height: 325px;
  display:inline-block;
  text-align:left;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
  line-height: 65px;
  color: #000000;
}
.productFeaturesContainer .featurelist .list2{
  width:329px; 
  height: 325px;
  vertical-align:bottom;
  display:inline-block;
}
.productFeaturesContainer .featurelist .list3{
  width: 255px; 
  height: 325px;
  vertical-align:bottom;
  display:inline-block;
  text-align:left;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
  line-height: 65px;
  color: #000000;
}
.productFeaturesContainer .solutions{
  height:798px;
}
.productFeaturesContainer .solutions .solutionsTitle{
  width: 643px;
  height: 46px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 38px;
  line-height: 46px;
  text-align: center;
  color: #000000;
}
.productFeaturesContainer .solutions .solutionsContent{
  height:752px;
  padding:106px 0 204px 0;
}
.productFeaturesContainer .solutions .solutionContent{
  width: 365px;
  height: 442px;
  display:inline-block;
  background: #F8F8F8;
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.1);
  border-radius: 18px;
  vertical-align:bottom;
}
.productFeaturesContainer .solutions .solutionContent2{
  margin:0 65px;
}
.productFeaturesContainer .solutions .solutionContent .solutionContentTop{
  width: 365px;
  height: 332px;
}
.productFeaturesContainer .solutions .solutionContent .solutionContentBottom{
  width: 365px;
  height: 110px;
  background: #FFFFFF;
  border-radius: 0px 0px 18px 18px;
  padding-top:41px;
}
.productFeaturesContainer .solutions .solutionContent .solutionContentBottom p{
  height: 27px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 27px;
  text-align: center;
  color: #000000;
}
</style>




// WEBPACK FOOTER //
// src/components/ProductFeatures.vue